export default function Contact() {
  return (
    <main className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Contact</h1>
      <div className="mt-6 grid md:grid-cols-2 gap-8">
        <div className="space-y-3 text-slate-700">
          <p><strong>Ecole La Voie Lactée</strong></p>
          <p>Rue des Arpenteurs 7<br/>1217 Meyrin / Genève</p>
          <p>Téléphone: <a className="text-amber-700" href="tel:+41227850202">+41 22 785 02 02</a></p>
          <p>Email: <a className="text-amber-700" href="mailto:ecole@lavoielactee.ch">ecole@lavoielactee.ch</a></p>
          <a className="inline-block mt-2 px-4 py-2 rounded-full bg-amber-500 text-white font-semibold hover:bg-amber-600" href="https://www.google.ch/maps/place/Voie+Lact%C3%A9e/@46.2308835,6.0651707,1157m" target="_blank" rel="noreferrer">Localiser sur la carte</a>
        </div>
        <div className="text-slate-600">
          <p>Vous pouvez utiliser le lien ci-contre pour ouvrir l'emplacement exact sur Google Maps.</p>
        </div>
      </div>
    </main>
  );
}
